<template>
     <div class="row">
        <div class="col-12 col-md-6 pb-4 pb-md-0">
            <text-card
                :title="trans('assessments.initial_evaluations')"
                :description="trans('assessments.measure_soft_skills')"
                :buttonText="testButtonsLabel(this.statusFirstTest)"
                :status="testStatuses(this.statusFirstTest)"
                :link="autoLoginUrl"
                :label="dateCompletedFirst && (trans('assessments.testCompletedOn') + dateCompletedFirst)"
                trackEvent="StartAssessment-1"
                v-bind:targetBlank="true"
            />
        </div>
        <div class="col-12 col-md-6">
            <text-card
                :title="trans('assessments.final_evaluation')"
                :description="trans('assessments.repeat_questions')"
                :buttonText="testButtonsLabel(this.statusSecondTest)"
                :status="testStatuses(this.statusSecondTest)"
                :is-disabled="isSecondTestAvailable ? false : true"
                :link="autoLoginUrl"
                :label="dateCompletedSecond && (trans('assessments.testCompletedOn') + dateCompletedSecond)"
                trackEvent="StartAssessment-2"
                v-bind:targetBlank="true"
            />
        </div>
    </div>
</template>

<script>
    import TextCard from "../molecules/cards/TextCard"

    export default {
        name: "AssessmentsCards",
        components:{ TextCard },
        props: {
            statusFirstTest: Number,
            statusSecondTest: Number,
            dateCompletedFirst: String,
            dateCompletedSecond: String,
            autoLoginUrl: String,
            isSecondTestAvailable: Number
        },

        methods:{
            testStatuses(test) {
                let status = 0;
                switch (test) {
                    case 0: {
                        status = 'not-started';
                        break;
                    }
                    case 1: {
                        status = 'completed';
                        break;
                    }
                    case 2: {
                        status = 'in-progress';
                        break;
                    }
                }
                return status;
            },

            testButtonsLabel(test) {
                let label = 0;
                switch (test) {
                    case 0: {
                        label = this.trans('assessments.start_test');
                        break;
                    }
                    case 1: {
                        label = this.trans('assessments.completed_test');
                        break;
                    }
                    case 2: {
                        label = this.trans('assessments.resume_test');
                        break;
                    }
                }
                return label;
            }
        }
    }
</script>
